/**
 * MONEY — AND A DIAL CODE — ALWAYS READ LEFT-TO-RIGHT — `899,00 dh`, never `dh 899,00`.
 *
 * Founder, 23/10/2026, screenshot of an Arabic shop's COD form: « me fait le rtl dans la devise, mais moi
 * je veux que la devise s'écrive left to right comme le fr ». Nothing formats the amount backwards —
 * `formatOfferMoney` writes `899,00 dh` on every shop. What flips it is the PARAGRAPH: inside `dir="rtl"`
 * the bidi algorithm reads `899,00` as a number run and `dh` as a Latin run, keeps each one internally
 * left-to-right, and then lays the two runs right-to-left — so the card paints `dh 899,00`.
 *
 * Two ways to pin it back, and which one applies depends on what sits around the amount:
 *  - the amount is ALONE in its element → `{@link LTR_ISOLATE_CSS}` on that element (no string to touch, so
 *    `textContent` stays exactly what the tests and the analytics read);
 *  - the amount is spliced into a translated SENTENCE (`الدفع عند الاستلام · 899,00 dh`) → there is no
 *    element to style, so {@link ltrIsolate} wraps it in the two invisible code points Unicode added for
 *    precisely this case.
 *
 * Both are scoped to the amount itself: the row around it stays right-to-left, the label keeps its side.
 */
/** `direction:ltr` + an isolate, for an element whose whole content is one amount or one dial code. */
export const LTR_ISOLATE_CSS = 'direction:ltr;unicode-bidi:isolate;';
/**
 * Les deux mêmes points de code, mais DANS la chaîne — définis une seule fois, dans `@aquilixshop/money`.
 *
 * C'est lui qui écrit les montants d'une boutique arabe (`formatMoney` y enferme déjà le sien), donc c'est
 * lui qui doit décider des caractères ; deux implémentations, et `stripLtrIsolate` ne défairait plus ce que
 * le formateur a posé. Ré-exportés ici parce que c'est l'adresse que connaissent les blocs.
 *
 * ATTENTION (23/10/2026) : sur un montant arabe, {@link LTR_ISOLATE_CSS} seul ne suffit PAS. `Intl` entoure
 * sa chaîne de marques U+200F, et une marque de direction DANS le texte gagne contre le `direction:ltr` de
 * l'élément qui le contient. C'est `formatMoney` qui les retire ; le CSS, lui, ne protège que les montants
 * écrits sans marques (`formatOfferMoney` hors arabe, un indicatif `+212`).
 */
export { ltrIsolate, stripLtrIsolate } from '@aquilixshop/money';
//# sourceMappingURL=ltrIsolate.js.map